import { NavLink } from "react-router-dom"
import styled, { css } from "styled-components"

import { ReactComponent as ChevronDownIcon } from "../../assets/icons/icon-chevrondown.svg"

export const Options = styled.div`
  position: absolute;
  top: ${props => props.$top}px;
  right: 10px;
  left: -10px;

  display: flex;
  flex-direction: column;

  min-width: 100%;
  background-color: #000;
  padding-top: 5px;

  white-space: nowrap;

  transition: opacity 0.15s ease-in-out;

  ${props =>
    props.$isVisible
      ? css`
          opacity: 1;
        `
      : css`
          opacity: 0;
          pointer-events: none;
        `}
`

export const Flag = styled.img`
  height: 100%;
  padding: 5px 0;
`

export const Chevron = styled(ChevronDownIcon)`
  width: 16px;
  height: 16px;
`

export const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;

  position: relative;
  background-color: transparent;
  border: none;

  height: 100%;
  padding: 10px 0;
  min-width: 50px;

  margin: 0 20px;

  cursor: pointer;
`

export const Label = styled.p`
  font-weight: bold;
  text-transform: uppercase;
`

export const Option = styled(NavLink)`
  display: flex;
  justify-content: center;

  box-sizing: border-box;

  max-height: ${props => props.$maxHeight}px;

  background-color: #000;

  color: ${props => props.theme.colours.black};
  font-size: 1em;
  text-transform: uppercase;
  text-decoration: none;
  text-align: right;

  border: none;

  cursor: pointer;

  transition: background-color 0.1s ease-in-out;

  p {
    transition: transform 0.1s ease-in-out;
    padding: 10px 15px;

    ${props =>
      props.$bold &&
      css`
        font-weight: bold;
      `}
  }

  ${Flag} {
    height: 80%;
  }

  :hover {
    color: #fff;

    p {
      transform: translateX(-3px);
    }
  }
`
